export const detectAdblock = () => fetch("/314159265/ads/banner_ad.js")
    // if we get any response status code we know the browser did not block the request
    .then((response) => isNaN(response.status))
    .catch(() => true);

